import { createContext } from 'react'
import type { useNotifications } from './useNotifications'

/** Everything `useNotifications` returns, shared by every bell on the page. */
export type NotificationsContextValue = ReturnType<typeof useNotifications>

export const NotificationsContext = createContext<NotificationsContextValue | null>(null)
